import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import RightbarCheque from 'pages/main/cheques/Rightbar'
import RightbarDI from 'pages/main/documentsIn/Rightbar'
import RightbarWTW from 'pages/main/service/transfer/Rightbar'
import DocumentRightbar from 'pages/main/reports/DocumentRightbar'
import PeriodPicker from 'pages/parts/PeriodPicker'
import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDate, findKeyFromArrayByValue } from 'helpers/helpers'

// Тип документа из истории движений -> ключ перевода
const DOCUMENT_NAMES = {
	'cheques': 'cheque',
	'documents_in': 'good_reception',
	'documents_return': 'return_to_supplier',
	'write_off': 'write_off',
	'inventory': 'inventory',
	'document_preparation': 'preparation',
	'document_breakdown': 'breakdown',
	'document_implementation': 'implementation',
	'documents_cheques_return': 'client_return',
	'wms_transfer_wms': 'transfer_between_wms',
	'wms_transfer_branch': 'transfer_between_branches',
	'wms_transfer_pos': 'moving_another_store',
}

function BalanceDetails({ filterDataParent, setFilterDataParent, poses, wms }) {
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('detail');
	const [data, setData] = useState({});
	const [selectedItem, setSelectedItem] = useState({});
	const [documentData, setDocumentData] = useState({});
	const [documentName, setDocumentName] = useState('');
	const [showDocumentRightbar, setShowDocumentRightbar] = useState(false);
	const [showRightBar, setShowRightBar] = useState({
		'cheque': false,
		'documents_in': false,
		'ewms_to_wms': false,
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: filterDataParent.date,
		end_date: filterDataParent.date,
		pos_id: filterDataParent.pos_id,
		wms_id: filterDataParent.wms_id,
		search: '',
	})

	async function searchWithFilter() {
		var filterUrl = "/report-balance-details"
		var urlParams = ""
		var filterDataCopy = { ...filterData }

		urlParams += returnSign(urlParams) + 'type=' + activeTab
		urlParams += returnSign(urlParams) + 'element_id=' + filterDataParent.element_id

		if (filterDataParent.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataParent.pos_id
		if (filterDataCopy.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)

		setDropdownIsOpen(false)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleSelectTemplate(item, index) {
		if (!item.main_entity_id || !item.main_entity_type) return

		// Документы с готовой боковой панелью открываем в ней
		if (item.main_entity_type === 'cheques') return toggleRightbarCheque(true, item, index)
		if (item.main_entity_type === 'documents_in') return toggleRightbarDI(true, item, index)
		if (item.main_entity_type === 'wms_transfer_pos') return toggleRightbarEWTW(true, item, index)

		// Остальные — универсальным просмотром документа
		toggleDocumentRightbar(true, item)
	}

	async function toggleDocumentRightbar(boolean = false, item = {}) {
		if (!boolean) {
			setDocumentData({})
			setShowDocumentRightbar(false)
			return
		}

		var urlParams = ''
		urlParams += returnSign(urlParams) + 'type=' + item.main_entity_type
		urlParams += returnSign(urlParams) + 'id=' + item.main_entity_id

		const response = await GET('/report-balance-document' + urlParams, {}, { loader: true })
		if (httpOk(response)) {
			setDocumentData(response.data)
			setDocumentName(documentTypeName(item.main_entity_type))
			setShowDocumentRightbar(true)
		}
	}

	function documentTypeName(type) {
		return DOCUMENT_NAMES[type] ? t(DOCUMENT_NAMES[type]) : t('document')
	}

	async function toggleRightbarCheque(boolean = false, item = {}) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.balance_details.length; i++) {
			dataCopy.balance_details[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/cheques/${item.main_entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data.data)
				setShowRightBar({ ...showRightBar, 'cheque': true })
			}
		}
		if (!boolean) {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'cheque': true })
		}
	}

	async function toggleRightbarDI(boolean = false, item = {}) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.balance_details.length; i++) {
			dataCopy.balance_details[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/documents-in/${item.main_entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'documents_in': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'documents_in': false })
		}
	}

	async function toggleRightbarEWTW(boolean = false, item = {}) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.balance_details.length; i++) {
			dataCopy.balance_details[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/service/wms-transfer-pos/${item.main_entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'ewms_to_wms': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'ewms_to_wms': false })
		}
	}

	useEffect(() => {
		if (!filterDataParent.modalProducts)
			setSelectedItem({})
	}, [filterDataParent.modalProducts]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL */}
			<Modal show={filterDataParent.modalProducts} animation={false} centered size="xl"
				onHide={() => setFilterDataParent({ ...filterDataParent, 'modalProducts': false })}>
				<Modal.Header closeButton>
					{/* В заголовке — по какому продукту открыта детализация */}
					<Modal.Title>
						{filterDataParent.element_name ? filterDataParent.element_name : t('information')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<>
						<div className="d-flex mb-3">
							<div className="d-flex flex-wrap gap-2">
								<div>
									<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
										<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
											{t('filter')}
										</Dropdown.Toggle>

										<Dropdown.Menu className="dropdown-filter">
											<div className="row">
												<div className="form-group col-md-6">
													<label>{t('wms')}</label>
													<Select
														// isClearable
														options={wms}
														value={wms.find(option => option.id === filterData.wms_id) || ''}
														onChange={(option) => setFilterData({ ...filterData, 'wms_id': option ? option.id : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
											<div className="row">
												<div className="form-group col-md-12">
													<label>{t('period')}</label>
													<PeriodPicker
														withTime={false}
														startDate={filterData.start_date}
														endDate={filterData.end_date}
														minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
														maxDate={new Date(new Date().getFullYear(), 11, 31)}
														onChange={(period) => setFilterData({ ...filterData, ...period })}
													/>
												</div>
											</div>
											<div className="row mt-3">
												<div className="col-md-12">
													<div className="d-flex justify-content-end gap-2">
														<button className="btn btn-secondary"
															onClick={() => setDropdownIsOpen(false)}>
															{t('cancel')}
														</button>
														<button className="btn btn-primary"
															onClick={() => searchWithFilter(false)}>
															{t('apply')}
														</button>
													</div>
												</div>
											</div>
										</Dropdown.Menu>
									</Dropdown>
								</div>
								<button className={`btn ${activeTab === 'detail' ? 'btn-primary' : 'btn-secondary'}`}
									onClick={() => setActiveTab('detail')}>
									{t('in_detail')}
								</button>
								<button className={`btn ${activeTab === 'checkpoint' ? 'btn-primary' : 'btn-secondary'}`}
									onClick={() => setActiveTab('checkpoint')}>
									{t('check_point')}
								</button>
							</div>
						</div>

						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterDataParent.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterDataParent.pos_id, 'name')}
									</span>
								}
								{filterData.wms_id &&
									<span className="me-2">
										<b>{t('wms')}: </b>
										{findKeyFromArrayByValue(wms, 'id', filterData.wms_id, 'name')}
									</span>
								}
							</div>
						</div>
					</>

					{activeTab === 'detail' &&
						<div className="row">
							<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
								<table className="table table-bordered table-hover cursor mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '20%' }}>{t('type')}</th>
											<th style={{ 'width': '15%' }}>{t('document')}</th>
											<th style={{ 'width': '15%' }}>{t('element')}</th>
											<th style={{ 'width': '15%' }}>{t('product')}</th>
											<th style={{ 'width': '10%' }}>{t('wms')}</th>
											<th style={{ 'width': '10%' }}>{t('created_by')}</th>
											<th style={{ 'width': '7%' }} className="text-end text-nowrap">{t('quantity')}</th>
											<th style={{ 'width': '8%' }} className="text-end text-nowrap">{t('balance2')}</th>
											<th style={{ 'minWidth': '130px' }} className="text-center text-nowrap">{t('date')}</th>
										</tr>
									</thead>
									<tbody>
										{data?.balance_details?.map((item, index) => (
											<tr key={index} onClick={() => handleSelectTemplate(item, index)}>
												<td className={`text-center ${item.transaction_type === 'plus' ? 'bg-success text-white' : 'bg-danger text-white'}`}>
													{index + 1}
												</td>
												<td className="td-ellipsis" title={item.movement_name}>{item.movement_name}</td>
												{/* id документа клиенту ни о чём не говорит — показываем только тип,
													а номер оставляем в подсказке для разбора спорных движений */}
												<td className="td-ellipsis text-primary"
													title={documentTypeName(item.main_entity_type) + (item.main_entity_id ? ` №${item.main_entity_id}` : '')}>
													{documentTypeName(item.main_entity_type)}
												</td>
												<td className="td-ellipsis">{item.product_name}</td>
												<td className="td-ellipsis">{item.main_product_name}</td>
												<td className="td-ellipsis" title={item.wms_name}>{item.wms_name}</td>
												<td className="td-ellipsis" title={item.created_by}>
													{item.created_by_name ? item.created_by_name : item.created_by}
												</td>
												{/* В инвентаризации в леджер уходит расхождение, а в отчёте
													нужно посчитанное количество — его и показываем */}
												<td className={`text-end ${item.counted_quantity !== null && item.counted_quantity !== undefined
													? '' : item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>
													{item.counted_quantity !== null && item.counted_quantity !== undefined
														? formatMoney(item.counted_quantity, 3)
														: formatMoney(item.quantity, 3)}
												</td>
												<td className="text-end">{formatMoney(item.balance, 3)}</td>
												<td className="text-center">{formatDate(item.created_at, 'dd.MM.yy HH:mm:ss')}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					}

					{activeTab === 'checkpoint' &&
						<div className="row">
							<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th className="text-nowrap" title={t('date')}>{t('date')}</th>
											<th className="text-end text-nowrap" title={t('balance2')}>{t('balance2')}</th>
											<th className="text-end td-ellipsis" title={t('good_reception')}>{t('good_reception')}</th>
											<th className="text-end td-ellipsis" title={t('sales')}>{t('sales')}</th>
											<th className="text-end td-ellipsis" title={t('inventory')}>{t('inventory')}</th>
											<th className="text-end td-ellipsis" title={t('write_off')}>{t('write_off')}</th>
											<th className="text-end td-ellipsis" title={t('preparation')}>{t('preparation')}</th>
											<th className="text-end td-ellipsis" title={t('breakdown')}>{t('breakdown')}</th>
											<th className="text-end td-ellipsis" title={t('return_to_supplier')}>{t('return_to_supplier')}</th>
											<th className="text-end td-ellipsis" title={t('transfer_between_wms')}>{t('transfer_between_wms')}</th>
											<th className="text-end td-ellipsis" title={t('transfer_between_branches')}>{t('transfer_between_branches')}</th>
											<th className="text-end td-ellipsis" title={t('moving_another_store')}>{t('moving_another_store')}</th>
											<th className="text-end td-ellipsis" title={t('implementation')}>{t('implementation')}</th>
											<th className="text-end td-ellipsis" title={t('client_return')}>{t('client_return')}</th>
											<th className="text-end td-ellipsis" title={t('other')}>{t('other')}</th>
											<th className="text-end td-ellipsis" title={t('movements')}>{t('movements')}</th>
											<th className="text-end text-nowrap" title={t('balance2')}>{t('balance2')}</th>
										</tr>
									</thead>
									<tbody>
										{data?.balanceDaily?.map((item, index) => (
											<tr key={index}>
												<td className="text-center">{index + 1}</td>
												<td className="text-nowrap">{formatDate(item.date, 'dd.MM.yy')}</td>
												<td className="text-end">{formatMoney(item.start_balance, 3)}</td>
												<td className={`text-end ${Number(item.incoming) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.incoming, 3)}</td>
												<td className={`text-end ${Number(item.sold) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.sold, 3)}</td>
												<td className={`text-end ${Number(item.inventory) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.inventory, 3)}</td>
												<td className={`text-end ${Number(item.write_off) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.write_off, 3)}</td>
												<td className={`text-end ${Number(item.preparation) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.preparation, 3)}</td>
												<td className={`text-end ${Number(item.breakdown) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.breakdown, 3)}</td>
												<td className={`text-end ${Number(item.return_supplier) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.return_supplier, 3)}</td>
												<td className={`text-end ${Number(item.transfer_wms_to_wms) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.transfer_wms_to_wms, 3)}</td>
												<td className={`text-end ${Number(item.transfer_pos_to_pos) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.transfer_pos_to_pos, 3)}</td>
												<td className={`text-end ${Number(item.transfer_pos_to_external) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.transfer_pos_to_external, 3)}</td>
												<td className={`text-end ${Number(item.implementation) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.implementation, 3)}</td>
												<td className={`text-end ${Number(item.client_return) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.client_return, 3)}</td>
												<td className={`text-end ${Number(item.other) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.other, 3)}</td>
												<td className={`text-end ${Number(item.total_movement) < 0 ? 'text-danger' : 'text-success'}`}>{formatMoney(item.total_movement, 3)}</td>
												<td className={`text-end ${Number(item.calculated_end_balance) !== Number(item.end_balance) ? 'bg-warning' : ''}`}
													title={Number(item.calculated_end_balance) !== Number(item.end_balance) ? `${t('calculated_balance')}: ${formatMoney(item.calculated_end_balance, 3)}` : ''}>
													{formatMoney(item.end_balance, 3)}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					}
				</Modal.Body>
			</Modal >
			{/* MODAL */}

			{showRightBar.cheque &&
				<RightbarCheque
					showRightBar={showRightBar.cheque}
					setShowRightBar={setShowRightBar}
					selectedItem={selectedItem}>
				</RightbarCheque>
			}

			{showRightBar.documents_in &&
				<RightbarDI
					showRightBar={showRightBar.documents_in}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</RightbarDI>
			}

			{showRightBar.ewms_to_wms &&
				<RightbarWTW
					showRightBar={showRightBar.ewms_to_wms}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</RightbarWTW>
			}

			{showDocumentRightbar &&
				<DocumentRightbar
					showRightBar={showDocumentRightbar}
					setShowRightBar={setShowDocumentRightbar}
					documentName={documentName}
					posName={findKeyFromArrayByValue(poses, 'id', filterDataParent.pos_id, 'name')}
					data={documentData}>
				</DocumentRightbar>
			}
		</>
	)
}

export default BalanceDetails
